import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: stretch;
  padding: 1rem 1.5rem;
  flex-shrink: 0;

  @media (max-width: 1000px) {
    padding: 0.5em 2em;
  }

  @media (max-width: 700px) {
    padding: 0.5em;
    gap: 0.5em;
    flex-direction: column;
  }
  gap: 1rem;
  background: linear-gradient(180deg, var(--ui-surface), var(--ui-surface-alt));
  max-height: calc(100vh - 35px);

  .container-fullscreen {
    position: absolute;
    display: none;
    justify-content: center;
    overflow: hidden;
    z-index: -100;
    align-items: center;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: black;
  }
`;

export const ImageWrapper = styled.div`
  flex-shrink: 0;
  box-sizing: border-box;
  display: flex;
  padding: 0.9rem;
  flex-shrink: 1;
  max-width: 500px;
  min-height: 0;
  flex-direction: column;
  justify-content: flex-start;
  border: 1px solid var(--ui-border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-soft);
  background-color: var(--ui-bg);

  @media (max-width: 700px) {
    height: 700px;
  }

  .main-image-box {
    flex-shrink: 0;

    &:hover {
      // add black tint absolute
    }
  }

  .main-image-clickbox {
    width: 100%;
    background-color: var(--ui-accent);
    color: var(--ui-day);
    display: flex;

    padding: 0.55rem 0.65rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.65rem;
    border-radius: var(--radius-sm) var(--radius-sm) 0 0;
    min-height: 46px;

    .start-labeling-button {
      all: unset;
      background-color: inherit;
      display: flex;
      justify-content: center;
      gap: 0.1em;
      color: inherit;
      font-weight: 600;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }

      &:focus-visible {
        outline: 2px solid var(--ui-day);
        outline-offset: 2px;
      }
    }

    > span,
    > span * {
      background-color: inherit;
    }

    > span {
      display: inline-flex;
      align-items: center;
      gap: 0.35rem;
      font-size: 0.95rem;
      line-height: 1.25;
      white-space: nowrap;
      overflow: visible;
    }

    > span > span {
      display: inline-block;
      line-height: 1.25;
      padding-bottom: 1px;
    }

    img {
      background-color: inherit;
      width: 20px;
      height: 20px;
      flex-shrink: 0;
      text-align: center;
      vertical-align: middle;
    }
  }

  .main-image {
    vertical-align: top;
    width: 100%;
    object-fit: contain;

    &:hover {
      cursor: pointer;
    }
    &--loading {
      filter: brightness(50%);
    }
  }
  .spinner {
    position: absolute;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: transparent;
  }
`;
